import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductionOrderOperation, ProductionOrderOperationCreate, ProductionOrderOperationFilter } from '../data/productionOrderOperation';

export function createProductionOrderOperationService(client: AxiosInstance) {
  return createCrudService<ProductionOrderOperation, ProductionOrderOperationCreate, ProductionOrderOperationFilter>(
    client,
    '/manufacturing/ProductionOrderOperation',
    'id',
  );
}

export type ProductionOrderOperationService = CrudService<ProductionOrderOperation, ProductionOrderOperationCreate, ProductionOrderOperationFilter>;
